export default __webpack_public_path__ + "static/media/close-menu.927284eb.svg";